import {
  childErrorReduc,
  isRenteEducationRequired
} from '@@viewHelpers/validations/guaranteesPrevTns.js';
import { filter, propEq, propOr } from 'ramda';

const useNiveauxGarantiesTarifsPrevTnsRenteEducationForm = ({
  form,
  guarantees,
  getMiddleText
}) => {
  const rEduc = form.watch('guarantees.OPTION_REDUC.selected');

  const { OPTION_REDUC, REDUC_CAP, REDUC_MAD } = guarantees;

  const renteEducationCotisation = [
    {
      displayed: rEduc,
      label: getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_DECES_REDUC_LABEL'),
      monthlyAmount: propOr(0.0, 'monthlyPrice', REDUC_CAP),
      yearlyAmount: propOr(0.0, 'annualPrice', REDUC_CAP)
    }
  ];

  return {
    rEduc,
    isRenteEducationRequired,
    childErrorReduc,
    OPTION_REDUC,
    REDUC_MAD,
    renteEducationCotisation: filter(propEq('displayed', true), renteEducationCotisation)
  };
};

export default useNiveauxGarantiesTarifsPrevTnsRenteEducationForm;
